import React, { useState } from "react";
import axios from "axios";
import { ActionIcon } from "@mantine/core";
import toast from "react-hot-toast";

import { IconDownload } from "@tabler/icons-react";

export default function EffortCsvDownload({ effortId }) {
  const [loading, setLoading] = useState(false);

  function onClick() {
    setLoading(true);

    axios
      .post(`/campaign-effort-csv-bulk/`, { campaign_effort_id: effortId })
      .then(() => {
        setLoading(false);
        toast.success("Making CSV. A link will be sent when it's ready");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <ActionIcon
      color="gray"
      size="lg"
      variant="light"
      radius="xl"
      loading={loading}
      onClick={onClick}
      title="Download CSV"
    >
      <IconDownload size={16} />
    </ActionIcon>
  );
}
